import React, { useState } from 'react';

function NutritionGuidePage(){
  return(
  <div className="container mt-4">
    <h2><i className="bi bi-book me-2"></i>Nutrition Guide</h2>
    <div className="card mt-3">
      <div className="card-body">
        <h5>Recommended Daily Intake</h5>
        <ul className="list-group list-group-flush">
          <li className="list-group-item">Calcium: 1000mg</li>
          <li className="list-group-item">Iron: 27mg</li>
          <li className="list-group-item">Folic Acid: 600μg</li>
        </ul>
      </div>
    </div>
  </div>
);

}

export default NutritionGuidePage;